export const EMAIL_RESEND_DELAY = 60; // in seconds
